import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as actions from './ZccInstallations.ducks';
import moment from 'moment';

// landscape components
import Grid from 'zignal-landscape/lib/Grid';
import GridContent from 'zignal-landscape/lib/GridContent';
import Row from 'zignal-landscape/lib/Row';
import Heading from 'zignal-landscape/lib/Heading';

import SortNoneIcon from 'zignal-landscape/lib/Icon/SortNoneIcon';
import SortAscendingIcon from 'zignal-landscape/lib/Icon/SortAscendingIcon';
import SortDescendingIcon from 'zignal-landscape/lib/Icon/SortDescendingIcon';

import Table from 'components/Table';
import TableLoader from 'components/TableLoader';
import ZccInstallationRow from './components/ZccInstallationRow';
import ZccNotification from './components/ZccNotification';


export const mapStateToProps = (
  (state) => ({
    loading: state.ZccInstallations.loading,
    zccInstallations: state.ZccInstallations.zccInstallations,
    sortingAttribute: state.ZccInstallations.sortingAttribute,
    isAscendingSort: state.ZccInstallations.isAscendingSort,
    notification: state.ZccInstallations.notification,
    timezone: state.AppUser.user.timezone,
  })
);

export const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return Object.assign({}, stateProps, dispatchProps, ownProps);
};

class ZccInstallations extends Component {

  componentDidMount(){
    const { fetchZccInstallations } = this.props;
    fetchZccInstallations();
  }

  render() {
    const {
      loading,
      zccInstallations,
      setSortAttribute,
      sortingAttribute,
      isAscendingSort,
      notification,
      timezone,
      unSetZccNotification
    } = this.props;

    const setIcon = (attr) => {
      if (attr === sortingAttribute) {
        return isAscendingSort ? SortAscendingIcon : SortDescendingIcon;
      }
      return SortNoneIcon;
    };

    const emptyTableProps ={
      header: 'No Command Center Installations',
      body: <span>No Command Centers installed</span>
    };

    const title = 'Command Centers Currently Installed';

    const headers = [
      { key: 'account', label: 'Account Name', Icon: setIcon('account'), onClick: () => setSortAttribute('account') },
      { key: 'name', label: 'ZCC Name', Icon: setIcon('name'), onClick: () => setSortAttribute('name') },
      { key: 'id', label: 'ZCC ID', Icon: setIcon('id'), onClick: () => setSortAttribute('id') },
      { key: 'version', label: 'ZCC Version', Icon: setIcon('version'), onClick: () => setSortAttribute('version') },
      { key: 'lastPing', label: 'Last Ping', Icon: setIcon('lastPing'), onClick: () => setSortAttribute('lastPing') },
    ];

    const rows = zccInstallations.map((item) => {
      return (
        <ZccInstallationRow
          key={item.id}
          installation={item}
          timezone={timezone}
        />
      );
    });

    return (
      <div>
        <Heading>{title}</Heading>
        <br />
        {notification && notification.message &&
        <ZccNotification
          type={notification.type}
          title={notification.title}
          message={notification.message}
          onClick={unSetZccNotification}
        />
        }
        <TableLoader
          loading={loading}
          items={zccInstallations}
          emptyTableProps={emptyTableProps}
        >
          <GridContent>
            <Grid fluid>
              <Row>
                <Table headers={headers} sortable rows={rows} />
              </Row>
            </Grid>
          </GridContent>
        </TableLoader>
      </div>
    );
  }
}

ZccInstallations.propTypes = {
  // passed from backbone
  accountId: PropTypes.string,
  timezone: PropTypes.string,
  campaignId: PropTypes.string,
  zccInstallations: PropTypes.array,
  loading: PropTypes.bool,
  // state
  sortingAttribute: PropTypes.string,
  isAscendingSort: PropTypes.bool,
  notification: PropTypes.object,
  // actions
  fetchZccInstallations: PropTypes.func,
  setSortAttribute: PropTypes.func,
  unSetZccNotification: PropTypes.func,
};

ZccInstallations.defaultProps = {
  zccInstallations: [],
  timezone: moment.tz.guess()
};

export default connect(mapStateToProps, actions, mergeProps)(ZccInstallations);
